import { ReactNode } from 'react';

import {
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay
} from '@chakra-ui/react';

interface ModalProps {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

const Modal = ({ children, isOpen, onClose }: ModalProps) => (
  <ChakraModal isCentered size='xl' isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent maxWidth='unset' margin='11px'>
      <ModalCloseButton />
      <ModalBody padding={0}>{children}</ModalBody>
    </ModalContent>
  </ChakraModal>
);

export default Modal;
